import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { setToken } from '../../../redux/actions/salesToken'

class InitStoreFromQueryString extends Component {

  componentDidMount () {
    const urlSearchParams = new URLSearchParams(this.props.history.location.search)
    if (urlSearchParams.has('salesToken')) {
      this.props.setToken(urlSearchParams.get('salesToken'))
    }
  }

  render () {
    return null
  }
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = {
  setToken: setToken
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InitStoreFromQueryString))
